"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _jquery = require("jquery");

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Clean_Form = void 0;

Clean_Form = function () {
  function Clean_Form() {
    var $inputs = void 0;
    var onClass = void 0;
    var showClass = void 0;
    onClass = "on";
    showClass = "show";
    $inputs = (0, _jquery2.default)(".new-form input:not([type='checkbox']):not([type='radio']), .new-form textarea, .new-form select");
    if ($inputs.hasClass("error")) {

      $inputs.on("focus", function () {
        return (0, _jquery2.default)(this).removeClass("error").next("label").removeClass("error show on");
      });
    } else {
      $inputs.bind("checkval", function () {
        var label = void 0;
        label = (0, _jquery2.default)(this).next("label");
        if (this.value !== "") {
          return label.addClass(showClass);
        } else {
          return label.removeClass(showClass);
        }
      }).on("keyup", function () {
        return (0, _jquery2.default)(this).trigger("checkval");
      }).on("focus", function () {
        return (0, _jquery2.default)(this).next("label").addClass(onClass);
      }).on("blur", function () {
        return (0, _jquery2.default)(this).next("label").removeClass(onClass);
      }).trigger("checkval");
    }
  }

  return Clean_Form;
}();

exports.default = new Clean_Form();